'use client'

// lib files
import { sendPbsGtmEvent } from '@/lib/helpers/send-pbs-gtm-event';
import { ShowRowContent } from '@/lib/types/api/show-data';
import { useIdentity } from '@/lib/hooks/useIdentity';

// constants
import { RECOMMENDED_SHOWS_FEATURE_CATEGORY } from '@/lib/constants';

// components
import { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';
import ShowGrid from "@/components/ShowGrid/ShowGrid";

interface YouMightAlsoLikeGridProps {
  shows: ShowRowContent[];
  franchiseContext: boolean;
  showBadgeFlags?: ShowBadgeFlags;
  pageType: 'show' | 'video';
}

/**
 * Client-side wrapper component for the Show or Video Details pages in the "You Might Also Like" tab
 * The primary purpose is to send feature tracking events when show posters are clicked.
 */
const YouMightAlsoLikeGrid = (props: YouMightAlsoLikeGridProps) => {
  const { shows, franchiseContext, showBadgeFlags, pageType } = props;
  const { isSignedIn } = useIdentity()

  const handleShowPosterClick = (show: ShowRowContent, index?: number, linkHref?: string) => {
    const { title, slug } = show;
    sendPbsGtmEvent({
      show_title: title,
      pbs_content_id: slug,
      object_name: "show poster",
      object_type: "link",
      object_position: index !== undefined ? index + 1 : undefined,
      object_location: `${pageType} detail page you might also like grid`,
      object_action: "click",
      object_action_behavior: `user navigates to ${pageType} page`,
      object_url: linkHref,
      feature_name: "recommended show poster",
      feature_category: RECOMMENDED_SHOWS_FEATURE_CATEGORY,
      signed_in_status: isSignedIn,
    });
  };

  return (
    <ShowGrid
      enableShowGridCards={true}
      shows={shows}
      franchiseContext={franchiseContext}
      limit={14}
      onShowPosterClick={handleShowPosterClick}
      showBadgeFlags={showBadgeFlags}
    />
  );
};

export default YouMightAlsoLikeGrid;
